<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Ignored Timesheet Report
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container" style="padding-left: 16px;">
                <div style="width: 100%">
                    <ppl-report-filters (filterChanged)="filterChanged($event)" (metricChanged)="metricChanged($event)" [filterFields]="filterFields" [report]="'ignoreTimesheetReport'"></ppl-report-filters>
                </div>
                <div class="chart-info-container">
                    <nz-card id="chart">
                        @if(chartOptions){
                        <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [labels]="chartOptions.labels" [responsive]="chartOptions.responsive"
                            [colors]="chartOptions.colors" [title]="chartOptions.title"></apx-chart>
                        }
                    </nz-card>
                    <div class="detailed-data-container">
                        @if(ignoredTimesheetReportData){
                        <ppl-list-table [disableSort]="true" [pageConfig]="programName" [disableSearch]="true" [showCustomSearch]="false"
                            [data]="ignoredTimesheetReportData" [disableSelection]="true" [cols]="cols"
                            [gridTitle]="false" [pagination]="true" [loadPage]="false"
                            [enableActions]="false" [customDataLoaded]="true"  [rowsToDisplay]="20"  [tableScrollable]="true"
                            [tableWidth]="'25rem'" (rowDetailEvent)="rowClicked($event)" [from]="'reports'">
                        </ppl-list-table>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>